app.factory('saikuService', ['$q', '$http', 'baseService', 'objectHelper', 'config',
    function($q, $http, baseService, objectHelper, config) {

        function SaikuService() {

            this.login = function() {
                return $http({url: config.SAIKU_URL + '/saiku/session', headers: {'Content-Type': 'application/x-www-form-urlencoded'}, data: {
                    username: config.SAIKU_USERNAME,
                    password: config.SAIKU_PASSWORD
                },transformRequest: function(obj) {
                    var str = [];
                    for(var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                method: 'POST'}).then(
                    function(successResponse) {
                        console.log(successResponse);

                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getLoggedUser = function() {
                return baseService.get(config.SAIKU_URL + '/saiku/session').then(
                    function(successResponse) {
                        console.log(successResponse);

                        return successResponse;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.getRepository = function () {
                return  baseService.get(config.SAIKU_URL + '/saiku/api/repository?type=saiku').then(
                    function (successResponse) {
                        return successResponse;
                    },
                    function (errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.query = function(uuid, file) {
                return $http({url: config.SAIKU_URL + '/saiku/api/query/' + uuid, headers: {'Content-Type': 'application/x-www-form-urlencoded'}, data: { file: file, formatter: 'flattened' },
                    transformRequest: function(obj) {
                    var str = [];
                    for(var p in obj)
                        str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
                    return str.join("&");
                },
                    method: 'POST'}).then(
                    function(successResponse) {
                        return successResponse.data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

            this.execute = function (data) {
                return $http({url: config.SAIKU_URL + '/saiku/api/query/execute', headers: {'Content-Type': 'application/json', 'Accept': 'application/json, text/javascript, */*; q=0.01'}, data: data,
                    method: 'POST'}).then(
                    function(successResponse) {
                        return successResponse.data;
                    },
                    function(errorResponse) {
                        return $q.reject(errorResponse);
                    }
                );
            };

        }

        return new SaikuService();
    }
]);
